import { render, staticRenderFns } from "./checkRiskZhima.vue?vue&type=template&id=7bb95a8c&scoped=true&"
import script from "./checkRiskZhima.vue?vue&type=script&lang=js&"
export * from "./checkRiskZhima.vue?vue&type=script&lang=js&"
import style0 from "./checkRiskZhima.vue?vue&type=style&index=0&id=7bb95a8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb95a8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bb95a8c')) {
      api.createRecord('7bb95a8c', component.options)
    } else {
      api.reload('7bb95a8c', component.options)
    }
    module.hot.accept("./checkRiskZhima.vue?vue&type=template&id=7bb95a8c&scoped=true&", function () {
      api.rerender('7bb95a8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/checkRiskZhima.vue"
export default component.exports